import { components } from 'react-select';
import styled from 'styled-components';

export const CustomValueContainer = styled(components.ValueContainer)`
    && {
        padding: 0 0 0 8px;
    }
`;
